export default __webpack_public_path__ + "static/media/A3_21.9cbff716.mp3";